/**
 * Raw event emitted when a user authenticates and session info is loaded
 */

export enum RbcAuthRawEventName {
  CommonAuth = "CommonAuth",
}

export interface CommonAuthRawEvent {
  name: RbcAuthRawEventName.CommonAuth;
  properties: {
    /** RBC account name from session info (accountNameEn) */
    accountName?: string;
    /** RBC user tier from session info (tierEn) */
    tier?: string;
    /** RBC user province from session info (provinceCode) */
    user_province?: string;
  };
}
